import { createFileRoute } from "@tanstack/react-router";
import { getActivityEditPage } from "#/modules/beweegactiviteitenreeks/activities.functions";
import { BeweegactiviteitenreeksCrudPage } from "#/modules/beweegactiviteitenreeks/components/page.crud-beweegactiviteiten";

export const Route = createFileRoute(
  "/$locale/{-$schoolyear}/_authenticated/admin/activities/$id/edit/",
)({
  loader: ({ params }) => getActivityEditPage({ data: { id: params.id } }),
  component: AdminActivityEditPage,
});

function AdminActivityEditPage() {
  const loaderData = Route.useLoaderData();
  return (
    <BeweegactiviteitenreeksCrudPage
      beweegactiviteitenreeks={loaderData.beweegactiviteitenreeks}
      isEditRoute={loaderData.isEditRoute}
      basePath="../activities"
    />
  );
}
